
export const navItems = [
  {
    id: 1,
    title: "Home",
    path: "./",
    cName: "nav-item",
  },
  {
    id: 2,
    title: "About",
    path: "./About",
    cName: "nav-item",
  },
  {
    id: 3,
    title: "Product",
    path: "./product",
    cName: "nav-item",
  },
  {
    id: 4,
    title: "Contact",
    path: "./contact",
    cName: "nav-item",
  },
  {
    id: 5,
    title: "Stories",
    path: "./our-story",
    cName: "nav-item",
  },
  {
    id: 6,
    title: "User",
    path: "./user",
    cName: "nav-item",
  },
 
];

export const productDropdown = [
  {
    id: 1,
    title: "Shop",
    path: "./shop",
    cName: "submenu-item",
  },

  {
    id: 2,
    title: "Premium Beans",
    path: "./premiumBeans",
    cName: "submenu-item",
  },

  {
    id: 3,
    title: "Expert Baristas",
    path: "./expertbaristas",
    cName: "submenu-item",
  },
];

export const ourstoryDropdown = [
  {
    id: 1,
    title: "About",
    path: "./about",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Testimonials",
    path: "./testimonial",
    cName: "submenu-item",
  },
];

export const userLogoutDropdown = [
  {
    id: 1,
    title: "Login",
    path: "./login",
    cName: "submenu-item",
  },
  {
    id: 2,
    title: "Register",
    path: "./register",
    cName: "submenu-item",
  },
];

export const userLoginDropdown = [
  {
    id: 1,
    title: "Cart",
    path: "./cart",
    cName: "submenu-item",
  },

  {
    id: 2,
    title: "Profile",
    path: "./profile",
    cName: "submenu-item",
  },

];

